import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import icon from '../../assets/spinner.svg';

const Container = styled.div`
  display: flex;
  grid-column: 1 / span 2;
  height: 100%;
  min-height: ${props => props.height}vh;
  width: 100%;
`;

Container.defaultProps = {
  height: '50',
};

Container.propTypes = {
  height: PropTypes.string,
};

const Image = styled.img`
  height: 4rem;
  margin: auto;
  width: 4rem;
`;

const Spinner = props => (
  <Container height={props.height}>
    <Image src={icon} alt="Loading..." />
  </Container>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/base/Spinner.js